import React from "react";
import { Routes, Route } from "react-router-dom";
import Container from "@material-ui/core/Container";
import AppHeader from "../components/AppHeader";
import Home from "./pages/Home";
import Conjugate from "./pages/Conjugate";

const App = () => {
  return (
    <>
      <AppHeader />
      <Container
        style={{
          textAlign: "center",
          margin: "40px auto 150px auto",
          padding: "0px",
        }}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/conjugate" element={<Conjugate />} />
        </Routes>
      </Container>
    </>
  );
};

export default App;
